import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { TextComponent } from '../../config';
import { FieldOption } from './FieldOption';

export class TextFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<TextComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, reservedIds: Array<string>): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    return (
      !isReserved &&
      component.type === 'TEXT' &&
      (component as TextComponent).multiline === this.component.multiline
    );
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
